// Approval Values
export default { UNRESOLVED: 'unresolved', APPROVED: 'approved', DISAPPROVED: 'disapproved' };



// WEBPACK FOOTER //
// ./src/variables/reviewApprovalValues.js